var _path, _path2, _path3, _ellipse, _circle, _ellipse2, _ellipse3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateNoQuestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.125 31.875C35.25 31.125 32.125 35.375 32.125 38.625C32.125 41.875 33.5744 44.3891 32.875 47.5C32.1516 50.7176 31.0318 55.25 23.375 55.25C15.6249 55.25 10.6384 46.5982 12.7499 42.375C15.1249 37.625 17.9073 38.0443 18.7344 32.75C19.7499 26.25 17.1141 20.9522 18.7344 17.5C21.6091 11.3751 28.0302 11.8666 34.625 13.875C41.275 15.9002 44.246 17.6407 46.625 19.25C55.125 25 60.3284 29.5634 55.3749 31.875C51.6249 33.625 49 32.625 42.125 31.875Z",
    fill: "url(#paint0_linear_20633_75759)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1249 14.2499C36.5652 17.3093 39.1249 22.9504 31.625 25.875C28.625 27.0449 27.1998 25.25 21.375 25.25C16.53 25.25 12.75 27.5 11.5 33.25C9.94428 40.4064 18.0451 46.6173 22.1249 48.7499C27.6249 51.6249 34.1492 53.4459 41.3749 50.2499C47.25 47.6512 50.1231 43.9897 52.1249 39.8749C53.3749 37.3055 54.4326 31.25 53.625 25.25C53.032 20.8445 53.0297 16.9739 49.6249 12.3599C46.4999 8.12501 41.3749 7.87482 38.1249 14.2499Z",
    fill: "url(#paint1_linear_20633_75759)",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9631 43.3745C54.4332 44.2409 53.8716 46.2925 53.3922 48.7464C52.0041 55.8513 43.5024 51.519 44.0229 46.8402C44.3865 43.5724 46.6486 42.2971 50.9631 43.3745Z",
    fill: "url(#paint2_linear_20633_75759)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.78102,
    cy: 28.5865,
    rx: 2.60268,
    ry: 3.12322,
    transform: "rotate(20.4825 7.78102 28.5865)",
    fill: "url(#paint3_linear_20633_75759)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 40.2351,
    r: 1.25,
    fill: "url(#paint4_linear_20633_75759)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.6604,
    cy: 6.09463,
    rx: 1.85527,
    ry: 2.59738,
    transform: "rotate(72.8289 42.6604 6.09463)",
    fill: "url(#paint5_linear_20633_75759)",
    fillOpacity: 0.07
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9673,
    cy: 1.4396,
    rx: 1.05177,
    ry: 1.47247,
    transform: "rotate(72.8289 40.9673 1.4396)",
    fill: "url(#paint6_linear_20633_75759)",
    fillOpacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20633_75759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 45.2632C39.325 45.2632 45.2632 39.325 45.2632 32C45.2632 24.675 39.325 18.7368 32 18.7368C24.675 18.7368 18.7368 24.675 18.7368 32C18.7368 39.325 24.675 45.2632 32 45.2632ZM32 47.1579C40.3715 47.1579 47.1579 40.3715 47.1579 32C47.1579 23.6285 40.3715 16.8421 32 16.8421C23.6285 16.8421 16.8421 23.6285 16.8421 32C16.8421 40.3715 23.6285 47.1579 32 47.1579Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0315 29.12C35.0315 28.4328 34.8025 27.8467 34.3444 27.3617C33.8863 26.8766 33.2732 26.6341 32.5052 26.6341C31.5486 26.6341 30.821 26.8968 30.3225 27.4223C29.8374 27.9343 29.5949 28.6349 29.5949 29.5242C29.5949 29.8206 29.5006 30.0699 29.3119 30.272C29.1233 30.4606 28.874 30.5549 28.5642 30.5549C28.2677 30.5549 28.0185 30.4606 27.8164 30.272C27.6277 30.0699 27.5334 29.8206 27.5334 29.5242C27.5334 28.5945 27.7355 27.7659 28.1397 27.0383C28.5574 26.3107 29.1435 25.7448 29.898 25.3406C30.6526 24.9364 31.5216 24.7343 32.5052 24.7343C33.3675 24.7343 34.1423 24.9229 34.8294 25.3002C35.53 25.664 36.0757 26.1827 36.4665 26.8564C36.8572 27.5166 37.0526 28.2712 37.0526 29.12C37.0526 29.8476 36.938 30.4876 36.709 31.04C36.4799 31.5789 36.17 32.064 35.7793 32.4952C35.3886 32.9128 34.8833 33.3709 34.2635 33.8695C33.9402 34.1255 33.7044 34.4691 33.5562 34.9002C33.4079 35.3314 33.3338 35.7221 33.3338 36.0724C33.3338 36.3688 33.2395 36.6181 33.0509 36.8202C32.8623 37.0088 32.613 37.1032 32.3031 37.1032C32.0067 37.1032 31.7574 37.0088 31.5553 36.8202C31.3667 36.6181 31.2724 36.3688 31.2724 36.0724C31.2724 35.5065 31.4138 34.9137 31.6968 34.2939C31.9797 33.6741 32.3907 33.1352 32.9296 32.6771C33.4416 32.2459 33.8256 31.8888 34.0816 31.6059C34.3511 31.3229 34.5734 30.9794 34.7486 30.5752C34.9372 30.1709 35.0315 29.6859 35.0315 29.12ZM32.3031 38.0328C32.6938 38.0328 33.0239 38.1743 33.2934 38.4573C33.5764 38.7267 33.7178 39.0568 33.7178 39.4476C33.7178 39.8248 33.5764 40.1549 33.2934 40.4379C33.0239 40.7074 32.6938 40.8421 32.3031 40.8421C31.9258 40.8421 31.5957 40.7074 31.3128 40.4379C31.0433 40.1549 30.9086 39.8248 30.9086 39.4476C30.9086 39.0568 31.0433 38.7267 31.3128 38.4573C31.5957 38.1743 31.9258 38.0328 32.3031 38.0328Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20633_75759",
    x1: 33.178,
    y1: 52.9869,
    x2: 13.2085,
    y2: 12.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20633_75759",
    x1: 31.0882,
    y1: 49.6798,
    x2: 10.5263,
    y2: 10.2601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20633_75759",
    x1: 48.5277,
    y1: 51.9969,
    x2: 44.0168,
    y2: 43.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20633_75759",
    x1: 7.59561,
    y1: 31.3789,
    x2: 4.29268,
    y2: 26.0981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20633_75759",
    x1: 58.6609,
    y1: 41.3527,
    x2: 57.4558,
    y2: 39.0405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20633_75759",
    x1: 42.5283,
    y1: 8.41689,
    x2: 39.619,
    y2: 4.43003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20633_75759",
    x1: 40.8924,
    y1: 2.75611,
    x2: 39.2431,
    y2: 0.495928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20633_75759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3158,
    height: 30.3158,
    fill: "white",
    transform: "translate(16.8421 16.8421)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoQuestions);
export default __webpack_public_path__ + "static/media/emptyStateNoQuestions.a6e0ca22.svg";
export { ForwardRef as ReactComponent };